module.exports = __webpack_public_path__ + "img/position.bd06c34d.svg";